import Button from 'components/actions/Button';
import Dialog from 'components/overlays/Dialog';
import type { DialogProps } from 'helper/types';
import { useSelector } from 'react-redux';
import { getErrorDialogOpen } from 'store/slices/settingsPageSlice';

const Title = () => <p className='font-body text-20 text-medium leading-24'>Sorry, something went wrong</p>;

export interface CreateUserDialogProps {
    errorStatus?: number;
    onCancel?: () => void;
    onConfirm: () => void;
}

interface BodyProps {
    errorStatus?: DialogProps['errorStatus'];
}

const Body = ({ errorStatus }: BodyProps) => (
    <div className='text-16'>
        <div className='mb-10 display-flex justify-content-center'>
            <span className='rioglyph rioglyph-truck-breakdown text-77 text-gray-light' />
        </div>
        <p className='mb-15'>For technical reasons, we couldn&apos;t complete the action you tried to perform.</p>
        <p>
            Please try again or refresh the page. If that doesn&apos;t work, please contact the Control Center support
            team.
        </p>
        <p className='mt-20 text-14 text-gray-dark'>Error type {errorStatus}</p>
    </div>
);

interface FooterProps {
    onConfirm: DialogProps['onConfirm'];
}

const Footer = ({ onConfirm }: FooterProps) => (
    <div className='display-flex justify-content-end gap-10'>
        <Button data-testid='user-close-button' onClick={onConfirm} style='primary'>
            Close
        </Button>
    </div>
);

// TODO: errorStatus should be implemented in future and this default value removed.
const UserActionErrorDialog = ({ onConfirm, errorStatus = 500 }: CreateUserDialogProps) => {
    const showDialog = useSelector(getErrorDialogOpen);

    return (
        <Dialog
            data-testid='user-error-dialog'
            show={showDialog}
            title={<Title />}
            footer={<Footer onConfirm={onConfirm} />}
            body={<Body errorStatus={errorStatus} />}
            onClose={onConfirm}
            showCloseButton
        />
    );
};

export default UserActionErrorDialog;
